import { Link } from "react-router-dom";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="border-t border-white/5 px-6 md:px-12 py-12 mt-32">
            <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
                <div className="md:col-span-6">
                    <p className="font-display text-5xl md:text-6xl tracking-tightest leading-[0.78]">
                        Create<span className="text-[color:var(--midi-accent-strong)]"> to</span> share.
                    </p>
                </div>
                <div className="md:col-span-3 text-sm text-white/60 font-light space-y-2">
                    <p>Madrid · Worldwide</p>
                    <a
                        data-testid="footer-email"
                        href="mailto:hola@midipictures.com"
                        className="midi-link text-white"
                    >
                        hola@midipictures.com
                    </a>
                </div>
                <div className="md:col-span-3 text-sm text-white/50 font-light space-y-2">
                    <div className="flex gap-6">
                        <Link to="/work" className="midi-link">
                            Work
                        </Link>
                        <Link to="/services" className="midi-link">
                            Services
                        </Link>
                        <Link to="/contact" className="midi-link">
                            Contact
                        </Link>
                    </div>
                    <p className="text-white/30 mt-6 text-xs tracking-widest uppercase">
                        © {year} MIDI Pictures
                    </p>
                </div>
            </div>
        </footer>
    );
}
